import { render, staticRenderFns } from "./EnderecoFd.vue?vue&type=template&id=20a797eb&scoped=true&"
import script from "./EnderecoFd.vue?vue&type=script&lang=js&"
export * from "./EnderecoFd.vue?vue&type=script&lang=js&"
import style0 from "./EnderecoFd.vue?vue&type=style&index=0&id=20a797eb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20a797eb",
  null
  
)

export default component.exports